import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import './assignmentMenu.scss'
import styled from "styled-components";

const DraggingRow = styled.td`
  background: rgba(127, 207, 250, 0.3);
`;

const TableData = styled.td`
    &:first-of-type {
        min-width: 20ch;
    };
    align-content: center;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
`

const TableRow = styled.tr`
    color: ${props => props.isHighlighted ? `white` : `inherit`};
`

const StyledStaticTableRow = styled.tr`
    box-shadow: rgb(0 0 0 / 10%) 0px 20px 25px -5px,
        rgb(0 0 0 / 30%) 0px 10px 10px -5px;
    outline: #3e1eb3 solid 1px;
`

export const StaticTableRow = ({ row, isHighlighted }) => {
    return (
        <StyledStaticTableRow {...row.getRowProps({
                className: isHighlighted ? 'highlightedRow' : '',
            })}
        >
            <DragHandle isDragging />

            {/* {row.cells.map((cell, i) => {
                if (i === 0) {
                    return (
                        <StyledStaticData {...cell.getCellProps()}>
                            <span>{cell.render('Cell')}</span>
                        </StyledStaticData>
                    )
                }
            })} */}
        </StyledStaticTableRow>
    )
}

const HandleWrapper = styled.div`
    height: 1rem;
    vertical-align: bottom;
    display: inline-block;
    margin-right: 0.5rem;
    svg {
    width: 100%;
    height: 100%;
    }
    float: left;
    cursor: ${({ isDragging }) => (isDragging ? "grabbing" : "grab")};
`;

export const DragHandle = (props) => {
    return (    
        <HandleWrapper {...props}>
            <svg
                aria-hidden='true'
                focusable='false'
                data-prefix='fas'
                data-icon='grip-vertical'
                role='img'
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 320 512'
            >
                <path
                    fill='currentColor'
                    d='M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z'
                ></path>
            </svg>
        </HandleWrapper>
    )
}

const DraggableTableRow = ({
    row,
    rows,
    rowId,
    onMove,
    isHighlighted,
    onRowClick,
    underRowHeaderName,
}) => {
    const {
        attributes,
        listeners,
        transform,
        transition,
        setNodeRef,
        isDragging,
    } = useSortable({
        id: rowId,
    })
    const style = {
        transform: CSS.Transform.toString(transform),
        transition: transition,
    }
    
    return (<>
        <TableRow 
            ref={setNodeRef}
            style={style}
            onClick={e => {
                onRowClick(e, row, rows)
            }}
            {...row.getRowProps({
                className: isHighlighted ? 'highlightedRow' : '',
            })}
            isHighlighted={isHighlighted}
        >
            {isDragging ? (
                <DraggingRow colSpan={row.cells.length}>&nbsp;</DraggingRow>
            ) : (
                row.cells
                    .filter(x => x.column.Header !== underRowHeaderName)
                    .map((cell, i) => {
                        return (
                            <TableData {...cell.getCellProps()}>
                                {cell.render('Cell', { attributes: attributes, listeners: listeners })}
                            </TableData>
                        )
                    })
            )}
        </TableRow>
        <div>
            {row.cells
                .filter(x => x.column.Header === underRowHeaderName)
                .map((cell, i) => {
                        return (
                            // <TableData {...cell.getCellProps()}>
                                cell.render('Cell')
                            // </TableData>
                        )
                    })
            }
        </div>
    </>)
}

export default DraggableTableRow